import * as React from 'react';

import Box from '@opendoor/bricks/core/Box';

export const Page: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <Box
      mx="auto"
      maxWidth="678px"
      color="neutrals100"
      textAlign="center"
      fontSize={['s0', 's1']}
      paddingX={[7, 8, 0]}
      paddingTop={9}
    >
      {children}
    </Box>
  );
};
